/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate } from './ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate';
import {
  ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreateFromJSON,
  ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreateFromJSONTyped,
  ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreateToJSON,
} from './ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate';
import type { ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate } from './ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate';
import {
  ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreateFromJSON,
  ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreateFromJSONTyped,
  ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreateToJSON,
} from './ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate';

/**
 * @type ConversationalAgentInferencerCreatePolymorphic
 *
 * @export
 */
export type ConversationalAgentInferencerCreatePolymorphic =
  | ({ protocol: 'CELINA' } & ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate)
  | ({
      protocol: 'OPEN_AI_ASSISTANT';
    } & ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate);

export function ConversationalAgentInferencerCreatePolymorphicFromJSON(
  json: any,
): ConversationalAgentInferencerCreatePolymorphic {
  return ConversationalAgentInferencerCreatePolymorphicFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerCreatePolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerCreatePolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['protocol']) {
    case 'CELINA':
      return Object.assign(
        {},
        ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreateFromJSONTyped(
          json,
          true,
        ),
        { protocol: 'CELINA' } as const,
      );
    case 'OPEN_AI_ASSISTANT':
      return Object.assign(
        {},
        ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreateFromJSONTyped(
          json,
          true,
        ),
        { protocol: 'OPEN_AI_ASSISTANT' } as const,
      );
    default:
      throw new Error(
        `No variant of ConversationalAgentInferencerCreatePolymorphic exists with 'protocol=${json['protocol']}'`,
      );
  }
}

export function ConversationalAgentInferencerCreatePolymorphicToJSON(
  value?: ConversationalAgentInferencerCreatePolymorphic | null,
): any {
  if (value == null) {
    return value;
  }
  switch (value['protocol']) {
    case 'CELINA':
      return ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreateToJSON(value);
    case 'OPEN_AI_ASSISTANT':
      return ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreateToJSON(
        value,
      );
    default:
      throw new Error(
        `No variant of ConversationalAgentInferencerCreatePolymorphic exists with 'protocol=${value['protocol']}'`,
      );
  }
}
